import { 
  Megaphone, 
  Share2, 
  Code, 
  Search, 
  Bot, 
  Palette, 
  Layers, 
  Compass, 
  Building2,
  Tv,
  Globe,
  Radio,
  Zap
} from 'lucide-react';

export const servicesData = [
  {
    id: 'advertisement',
    title: 'Advertisement',
    categoryPath: '/services/advertisement',
    icon: Megaphone,
    description: 'Targeted high-impact advertisement campaigns across digital channels and premier physical media.',
    hasSubgroups: true,
    groups: [
      {
        name: 'Online',
        items: [
          { name: 'Google Ads', path: '/services/advertisement/online/google-ads' },
          { name: 'Meta Ads', path: '/services/advertisement/online/meta-ads' },
          { name: 'OTT Ads', path: '/services/advertisement/online/ott-ads' },
        ]
      },
      {
        name: 'Offline',
        items: [
          { name: 'PVR/INOX', path: '/services/advertisement/offline/pvr-inox' },
          { name: 'Lakme', path: '/services/advertisement/offline/lakme' },
          { name: 'CCD/Barista', path: '/services/advertisement/offline/ccd-barista' },
        ]
      }
    ]
  },
  {
    id: 'marketing',
    title: 'Marketing',
    categoryPath: '/services/marketing',
    icon: Share2,
    description: 'Multi-channel audience engagement, viral reach, and direct marketing pipelines.',
    hasSubgroups: false,
    items: [
      { name: 'Social Media Marketing', path: '/services/marketing/social-media-marketing' },
      { name: 'WhatsApp Marketing', path: '/services/marketing/whatsapp-marketing' },
      { name: 'OBD Calls Marketing', path: '/services/marketing/obd-calls-marketing' },
    ]
  },
  {
    id: 'development',
    title: 'Development',
    categoryPath: '/services/development',
    icon: Code,
    description: 'High-speed modern websites, e-commerce stores, custom software, and mobile apps.',
    hasSubgroups: false,
    items: [
      { name: 'Websites', path: '/services/development/websites' },
      { name: 'E Commerce', path: '/services/development/e-commerce' },
      { name: 'Mobile Apps', path: '/services/development/mobile-apps' },
      { name: 'Software', path: '/services/development/software' },
    ]
  },
  {
    id: 'seo',
    title: 'Search Engine Optimisation',
    categoryPath: '/services/search-engine-optimisation',
    icon: Search,
    description: 'Dominate traditional search engines and next-gen AI search engines (SEO, AEO, GEO, AIO).',
    hasSubgroups: false,
    items: [
      { name: 'SEO', path: '/services/search-engine-optimisation/seo' },
      { name: 'AEO', path: '/services/search-engine-optimisation/aeo' },
      { name: 'GEO', path: '/services/search-engine-optimisation/geo' },
      { name: 'AIO', path: '/services/search-engine-optimisation/aio' },
    ]
  },
  {
    id: 'ai-automation',
    title: 'AI Automation',
    categoryPath: '/services/ai-automation',
    icon: Bot,
    description: 'Smart AI workflows, automated voice calling, and intelligent WhatsApp bots.',
    hasSubgroups: false,
    items: [
      { name: 'WhatsApp AI Automation', path: '/services/ai-automation/whatsapp-ai-automation' },
      { name: 'AI Calls Automation', path: '/services/ai-automation/ai-calls-automation' },
      { name: 'Business Automation', path: '/services/ai-automation/business-automation' },
    ]
  },
  {
    id: 'designing-editing',
    title: 'Designing & Editing',
    categoryPath: '/services/designing-editing',
    icon: Palette,
    description: 'Premium visual brand design, high-converting pitch decks, brochures, and video editing.',
    hasSubgroups: false,
    items: [
      { name: 'Creative Designing', path: '/services/designing-editing/creative-designing' },
      { name: 'Brochure Designing', path: '/services/designing-editing/brochure-designing' },
      { name: 'Presentation Designing', path: '/services/designing-editing/presentation-designing' },
      { name: 'Catalogue Designing', path: '/services/designing-editing/catalogue-designing' },
      { name: 'Video Editing', path: '/services/designing-editing/video-editing' },
    ]
  },
  {
    id: 'integration',
    title: 'Integration',
    categoryPath: '/services/integration',
    icon: Layers,
    description: 'Seamless API connections, tracking tags, map routes, chat widgets, and UTM pipelines.',
    hasSubgroups: false,
    items: [
      { name: 'AI Integration', path: '/services/integration/ai-integration' },
      { name: 'API Integration', path: '/services/integration/api-integration' },
      { name: 'UTM Integration', path: '/services/integration/utm-integration' },
      { name: 'Analytics Tags Integration', path: '/services/integration/analytics-tags-integration' },
      { name: 'Map Integration', path: '/services/integration/map-integration' },
      { name: 'Chat Widget Integration', path: '/services/integration/chat-widget-integration' },
    ]
  },
  {
    id: 'consultations',
    title: 'Consultations',
    categoryPath: '/services/consultations',
    icon: Compass,
    description: 'High-level strategic advisory, market execution blueprints, and growth roadmaps.',
    hasSubgroups: false,
    items: [
      { name: 'Strategy', path: '/services/consultations/strategy' },
      { name: 'Blueprint', path: '/services/consultations/blueprint' },
      { name: 'Roadmap', path: '/services/consultations/roadmap' },
    ]
  },
  {
    id: 'on-site-dedicated',
    title: 'On Site & Dedicated Services',
    categoryPath: '/services/on-site-dedicated-services',
    icon: Building2,
    description: 'In-person operational support, team training, skill development, and sales handling.',
    hasSubgroups: false,
    items: [
      { name: 'In Person Support', path: '/services/on-site-dedicated/in-person-support' },
      { name: 'Team Training', path: '/services/on-site-dedicated/team-training' },
      { name: 'Team Development', path: '/services/on-site-dedicated/team-development' },
      { name: 'Sales Handling', path: '/services/on-site-dedicated/sales-handling' },
    ]
  }
];

// Helper function to find service item by current window location or path
export const getServiceByPath = (pathname) => {
  const cleanPath = (pathname || '').replace(/\/$/, '') || '/';
  for (const category of servicesData) {
    if (category.categoryPath === cleanPath || category.categoryPath === pathname) {
      return {
        categoryTitle: category.title,
        groupName: null,
        itemTitle: category.title,
        category
      };
    }
    if (category.hasSubgroups) {
      for (const group of category.groups) {
        for (const item of group.items) {
          if (item.path === cleanPath || item.path === pathname) {
            return {
              categoryTitle: category.title,
              groupName: group.name,
              itemTitle: item.name,
              category
            };
          }
        }
      }
    } else {
      for (const item of category.items) {
        if (item.path === cleanPath || item.path === pathname) {
          return {
            categoryTitle: category.title,
            groupName: null,
            itemTitle: item.name,
            category
          };
        }
      }
    }
  }
  return null;
};
